import { faCircle, faQuoteLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Carousel } from 'react-bootstrap';
import '../Slider/OwlSlider.css';
import avater from '../../image/avater.png';

const Testimonial = () => {
        const [index, setIndex] = useState();
    
      const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
      };
    return (
         <div id="testiminial" className="owl-slider">
           <div className="">
            <h2 className="text-center text-white mb-3"><span>TESTIMONIAL</span> MODULE</h2>
            <h6 className="text-center text-white">Borderless Testimonial</h6>
            <div className="separator text-center">
                    <span><FontAwesomeIcon icon={faCircle}/></span>
                </div>
            <div className="mt-3 mainTest">
            <Carousel activeIndex={index} onSelect={handleSelect}>
               
               <Carousel.Item>
                <Carousel.Caption>
                  <div className="d-flex">
                  <div className="testimonial">
                   <div className="testLeft">
                        <FontAwesomeIcon icon={faQuoteLeft}/>
                        <p>
                        Service provided was professional and prompt! I highly recommend. I was provided a high quality service.
                        </p>
                    </div>
                    <div className="d-flex avater mt-3">
                    <img src={avater} alt="" />
                    <h6>Ammar President</h6>
                    </div>
                   </div>
                   <div className="testimonial">
                   <div className="testLeft">
                        <FontAwesomeIcon icon={faQuoteLeft}/>
                        <p>
                        Service provided was professional and prompt! I highly recommend. I was provided a high quality service.
                        </p>
                    </div>
                    <div className="d-flex avater mt-3">
                    <img src={avater} alt="" />
                    <h6>Ammar President</h6>
                    </div>
                   </div>
                  </div>
                </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                <Carousel.Caption>
                  <div className="d-flex">
                  <div className="testimonial">
                   <div className="testLeft">
                        <FontAwesomeIcon icon={faQuoteLeft}/>
                        <p>
                        Service provided was professional and prompt! I highly recommend. I was provided a high quality service.
                        </p>
                    </div>
                    <div className="d-flex avater mt-3">
                    <img src={avater} alt="" />
                    <h6>Ammar President</h6>
                    </div>
                   </div>
                   <div className="testimonial">
                   <div className="testLeft">
                        <FontAwesomeIcon icon={faQuoteLeft}/>
                        <p>
                        Service provided was professional and prompt! I highly recommend. I was provided a high quality service.
                        </p>
                    </div>
                    <div className="d-flex avater mt-3">
                    <img src={avater} alt="" />
                    <h6>Ammar President</h6>
                    </div>
                   </div>
                  </div>
                </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                <Carousel.Caption>
                  <div className="d-flex">
                  <div className="testimonial">
                   <div className="testLeft">
                        <FontAwesomeIcon icon={faQuoteLeft}/>
                        <p>
                        Service provided was professional and prompt! I highly recommend. I was provided a high quality service.
                        </p>
                    </div>
                    <div className="d-flex avater mt-3">
                    <img src={avater} alt="" />
                    <h6>Ammar President</h6>
                    </div>
                   </div>
                   <div className="testimonial">
                   <div className="testLeft">
                        <FontAwesomeIcon icon={faQuoteLeft}/>
                        <p>
                        Service provided was professional and prompt! I highly recommend. I was provided a high quality service.
                        </p>
                    </div>
                    <div className="d-flex avater mt-3">
                    <img src={avater} alt="" />
                    <h6>Ammar President</h6>
                    </div>
                   </div>
                  </div>
                </Carousel.Caption>
                </Carousel.Item>
               
            </Carousel>
            </div>
            
        </div>
     </div>
    );
};

export default Testimonial;